module.exports = __webpack_public_path__ + "8181b6db818003d78b31f5c33205acd8.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/virtual-sports/assets/vfl.png
// module id = 1782
// module chunks = 2